<template>
    <dl>
        <template v-for="item in items">
            <dt @click="$set(item, 'open', !item.open)" class="cursor-pointer text-underline">
                <div class="d-flex flex-align-center">
                    <span class="flex-child-fixed h6 mr-1">
                        <i class="icon-cr primary" :class="{'icon-plus': !item.open, 'icon-less': item.open}"></i>
                    </span>
                    <h3 class="h6">{{item.head}}</h3>
                </div>

            </dt>
            <dl class="collapsible my-0" :class="{opened: item.open}">
                <div v-if="item.html" v-html="item.html" class="ml-4"></div>
                <p v-else-if="item.text.constructor === Array"
                   class="ml-4" v-for="paragraph in item.text">
                    {{paragraph}}
                </p>
                <p v-else class="ml-4">{{item.text}}</p>
            </dl>
        </template>
    </dl>
</template>

<script>
    export default {
        name: "CollapsibleList",

        props: {
            items: Array,
        }
    }
</script>